var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3011 5.55327C5.70523 3.71831 0 12.1207 0 12.1207C2.05388 14.2455 3.08082 15.7425 5.32488 16.9496L6.46593 15.4044C3.99366 14.2938 2.28209 11.9758 2.28209 11.9758C4.37401 9.31992 7.83518 8.06434 7.83518 8.06434C6.84628 10.4306 6.46593 11.2032 7.26466 14.4869L8.55785 12.845C8.21553 8.59557 10.6498 7.29175 12.7036 7.62973L14.3011 5.55327Z",
    fill: "#329DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58637 22.1167L20.0063 0L21.4136 1.83501L3.99366 24L2.58637 22.1167Z",
    fill: "#329DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7132 7.19517L17.6101 8.59557C17.6101 8.59557 21 10 21.832 11.9758C20 15 16.2029 16.0805 16.2029 16.0805C17.1157 13.9074 17.6101 13.0382 16.8494 9.56137L15.5943 11.1549C15.9746 15.163 13.5024 16.9496 11.3344 16.5151L9.81299 18.495C15.1759 19.5091 20.2726 16.9496 24 11.9758C22.1898 9.43822 21.0527 8.70458 18.772 7.23312L18.7132 7.19517Z",
    fill: "#329DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.c26358a115a6e08a74d53953bf95cfc4.svg";
export { ForwardRef as ReactComponent };